import { RxQueryBase } from '../rx-query';
//# sourceMappingURL=rx-query.js.map